var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.color,style:(_vm.buttonStyle)},[(_vm.iconClass !== null)?_c('svg-icon',{style:({ marginRight: _vm.iconButton ? '0px' : '8px' }),attrs:{"icon-class":_vm.iconClass}}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }